interface Props {
  currentBalance?: number;
}

const CashSessionFooter: React.FC<Props> = ({ currentBalance }) => {
  return (
    <div className="border-t border-stroke px-6 py-4 dark:border-strokedark">

      <div className="flex items-center justify-between">

        <span className="text-gray-500 text-sm">
          Saldo actual de caja
        </span>

        <span className="text-lg font-semibold text-black dark:text-white">
          ${(currentBalance ?? 0).toFixed(2)}
        </span>

      </div>

    </div>
  );
};

export default CashSessionFooter;